import './OkulyonetimCategoryFilter.scss'

import { Collapse, Tree, TreeDataNode, TreeProps } from 'antd'
import React, { useEffect, useState } from 'react'

import deFlag from '../../../../images/okulyonetim/DE.png'
import enFlag from '../../../../images/okulyonetim/En.png'
import esFlag from '../../../../images/okulyonetim/Es.png'
import frFlag from '../../../../images/okulyonetim/Fr.png'
import itFlag from '../../../../images/okulyonetim/It.png'
import ruFlag from '../../../../images/okulyonetim/Ru.png'
import trFlag from '../../../../images/okulyonetim/tr-flag.png'
const { Panel } = Collapse

interface OkulyonetimCategoryFilterProps {
  treeData: TreeDataNode[] // Dinamik olarak API'den gelen veri
  checkedKeys: React.Key[] // Seçili kategorilerin anahtarları
  onCheck?: (checkedKeys: React.Key[], info: any) => void // Filtreleme için onCheck prop
}

const OkulyonetimCategoryFilter: React.FC<OkulyonetimCategoryFilterProps> = ({
  treeData,
  checkedKeys: initialCheckedKeys,
  onCheck,
}) => {
  const [updatedCheckedKeys, setUpdatedCheckedKeys] = useState<React.Key[]>(initialCheckedKeys)
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])

  useEffect(() => {
    setUpdatedCheckedKeys(initialCheckedKeys)
  }, [initialCheckedKeys])

  // Ana kategorilere ikon ekleyip, alt kategorilere eklemeyen fonksiyon
  const enhanceTreeData = (nodes: TreeDataNode[], depth = 0): TreeDataNode[] => {
    return nodes.map((node) => {
      // Bayrağı belirle (sende zaten var)
      let flagSrc;
      if (node.title === 'Türkçe') flagSrc = trFlag;
      else if (node.title === 'Almanca') flagSrc = deFlag;
      else if (node.title === 'Fransızca') flagSrc = frFlag;
      else if (node.title === 'İngilizce') flagSrc = enFlag;
      else if (node.title === 'İspanyolca') flagSrc = esFlag;
      else if (node.title === 'İtalyanca') flagSrc = itFlag;
      else if (node.title === 'Rusça') flagSrc = ruFlag;

      const levelClass =
          depth === 0 ? 'tree-level-0' : depth === 1 ? 'tree-level-1' : 'tree-level-2';

      return {
        ...node,
        className: levelClass,
        title: <span className={`tree-node-title ${levelClass}`}>{node.title as React.ReactNode}</span>,
        icon:
            depth === 0 && flagSrc ? (
                <img
                    className="okulyonetim-language-flag"
                    width={30}
                    height={20}
                    src={flagSrc}
                    alt={`${node.title}-flag`}
                />
            ) : undefined,
        children: node.children ? enhanceTreeData(node.children, depth + 1) : undefined,
      };
    });
  };

  const updatedTreeData = enhanceTreeData(treeData)

  useEffect(() => {
    const getParentKeys = (nodes: TreeDataNode[], keys: React.Key[]): React.Key[] => {
      const parentKeys: React.Key[] = []
      const traverse = (treeNodes: TreeDataNode[], parentKey?: React.Key) => {
        treeNodes.forEach((node) => {
          if (keys.includes(node.key) && parentKey) {
            parentKeys.push(parentKey)
          }
          if (node.children) {
            traverse(node.children, node.key)
          }
        })
      }
      traverse(nodes)
      return parentKeys
    }

    const newExpandedKeys = getParentKeys(treeData, updatedCheckedKeys)
    setExpandedKeys((prev) => Array.from(new Set([...prev, ...newExpandedKeys])))
  }, [treeData, updatedCheckedKeys])

  const handleCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
    let newCheckedKeys: React.Key[] = Array.isArray(checkedKeys) ? [...checkedKeys] : [...checkedKeys.checked]
    if (info.checked) {
      if (info.node.children && info.node.children.length > 0) {
        newCheckedKeys = newCheckedKeys.filter((key) => key !== info.node.key)
        newCheckedKeys.push(info.node.key)
      }
    } else {
      if (info.node.children && info.node.children.length > 0) {
        newCheckedKeys = newCheckedKeys.filter((key) => key !== info.node.key)
      } else {
        newCheckedKeys = newCheckedKeys.filter((key) => key !== info.node.key)
      }
    }

    setUpdatedCheckedKeys(newCheckedKeys)
    onCheck?.(newCheckedKeys, info)
  }

  const handleExpand = (keys: React.Key[]) => {
    setExpandedKeys(keys)
  }

  return (
    <div className="db-okulyonetim-category-filter">
      <div className="okulyonetim-category-filter">
        <Collapse expandIconPosition="end" bordered={false} defaultActiveKey={['1']}>
          <Panel header="Kategoriler" key="1">
            <div className="okulyonetim-category-filter-option">
              <Tree
                checkable
                checkedKeys={updatedCheckedKeys}
                onCheck={handleCheck}
                treeData={updatedTreeData} // Güncellenmiş veri setini kullan
                showIcon={true}
                expandedKeys={expandedKeys}
                onExpand={handleExpand}
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
  )
}

export default OkulyonetimCategoryFilter
